import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import Utilities from "../../../../../services/commonservice/utilities";
import { store } from "../../../../../context/StateProvider";
import ReportService from "../../../../../services/api/report.service";
import ManufacturerService from '../../../../../services/api/manufacturer.service';
import ProductService from '../../../../../services/api/product.service';
import Module from "../../../../templates/components/Module";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import HPTSelect from '../../../../templates/components/HPTSelect';

const ProductSummary = (props) => {
    const [productDetails, setProductDetails] = useState();
    const [startDate, setStartDate] = useState(moment().startOf("D"));
    const [endDate, setEndDate] = useState(moment().endOf("D"));
    const [manufacturerId, setManufacturerId] = useState(false);
    const [manufacturerList, setManufacturerList] = useState([]);
    const [productId, setProductId] = useState(false);
    const [productList, setProductList] = useState([])

    const stateAndDispatch = useContext(store);
    const state = stateAndDispatch.state;
    const [isLoader, setIsLoader] = useState(false)
    const [initialMessage, setInitialMessage] = useState(true)
    const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)

    const fetchReport = () => {
        setIsLoader(true)
        let reqObj = {
            StartDate: moment(startDate).toISOString(),
            EndDate: moment(endDate).toISOString()
        };
        if (manufacturerId) {
            reqObj.ManufacturerId = manufacturerId
        }
        if (locationId) {
            reqObj.PracticeLocationId = locationId
        }
        if (productId) {
            reqObj.ItemId = productId
        }
        setInitialMessage(false);

        ReportService.getManufacturerSummaryReport(reqObj)
            .then((res) => {
                setProductDetails(res);
                setIsLoader(false)
            })
            .catch((err) => {
                console.log(err);
                setProductDetails();
                setIsLoader(false)
            });
    };

    const productLookup = () => {
        const reqObj = {
            includePracticeItems: 'yes',
            isActive: true,
            itemType: 1,
            isManufacturer: 'yes'
        };
        if (locationId) {
            reqObj.practiceLocationId = locationId
        }
        if (manufacturerId) {
            reqObj.manufacturerId = manufacturerId
        }
        ProductService.productLookup(reqObj)
            .then(results => {
                if (results) {
                //    setProductId(results[0].id);
                    setProductList(results);
                }
            })
    }

    useEffect(() => {
        setIsLoader(true)
        let reqObj = {
            IsActive: 1
        };
        ManufacturerService.getAllManufacturer(reqObj)
            .then((res) => {
                setManufacturerList(res?.data);
             //   setManufacturerId(res.data[0]?.manufacturerId);
                setIsLoader(false)
            })
            .catch((err) => {
                console.log(err);
                setManufacturerList();
                setIsLoader(false)
            });
    }, []);

    useEffect(() => {
        productLookup()
    }, [locationId, manufacturerId]);  


    const columns = [
        {
            id: "subData",
            Header: "",
            accessor: (tc) => ""
        },
        {
            id: "manufacturer",
            Header: "Manufacturer",
            accessor: tc => tc.manufacturer,
            Footer: () => 'Grand Total'
        },
        {
            id: "salesTotal",
            Header: "Total Sales",
            accessor: tc => Utilities.toDollar(tc.salesTotal),
            Footer: info => {
                    const total = React.useMemo(
                      () =>
                        info.rows.reduce((sum, row) => (row.original.salesTotal) + sum, 0),
                      [info.rows]
                    )
                    return <>{Utilities.toDollar(total)}</>
                  },
        },
        {
            id: "quantityTotal",
            Header: "Total Quantity",
            accessor: tc => tc.quantityTotal
        }
    ]

    const tableSubColumns = [
        {
            id: "name",
            Header: "Name",
            accessor: (row) => row.name
        },
        {
            id: "quantityTotal",
            Header: "Quantity",
            accessor: (row) => row.quantityTotal
        },
        {
            id: "itemSubTotal",
            Header: "Product SubTotal",
            accessor: (row) => Utilities.toDollar(row.itemSubTotal)
        },
        {
            id: "discountTotal",
            Header: "Discount Total",
            accessor: (row) => Utilities.toDollar(row.discountTotal)
        },
        {
            id: "taxTotal",
            Header: "Tax Total",
            accessor: (row) => Utilities.toDollar(row.taxTotal)
        },
        {
            id: "itemTotal",
            Header: "Product Total",
            accessor: (row) => Utilities.toDollar(row.itemTotal)
        },
    ];

    const subDataAccessor = (row) => {
        return (
            <div className="mt-3 mb-3">
                <Table2
                    data={row.itemDetails}
                    columns={tableSubColumns}
                    expanded={true}
                />
            </div>
        );
    };


    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }
            <div className="row d-flex g-3">
                <div className='col-12 m-p-0'>
                    <Module title="Filters">
                        <div className='row d-flex'>
                            <div className='col-12 row d-flex justify-content-center mx-0 align-items-end report-filters'>

                                <DatePicker setLocationId={setLocationId} locationClearable={isLocationClearable} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />

                                <div className="col">
                                    <label>Manufacturer</label>
                                    <HPTSelect
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={manufacturerList}
                                        name="manufacturerId"
                                        isClearable={true}
                                        placeholder={"All Manufacturers"}
                                        value={manufacturerList && manufacturerList.find(obj => obj.manufacturerId === manufacturerId) || null}
                                        onChange={e => {
                                            if (e?.manufacturerId) {
                                                setManufacturerId(e.manufacturerId)
                                            }
                                            else {
                                                setManufacturerId()
                                            }
                                        }}
                                        getOptionLabel={(option) => option.manufacturer}
                                        getOptionValue={(option) => option.manufacturerId}
                                    />
                                </div>
                                <div className="col">
                                    <label>Product</label>
                                    <HPTSelect
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={productList}
                                        name="productId"
                                        isClearable={true}
                                        placeholder={"All Products"}
                                        value={productList && productList.find(obj => obj.id === productId) || null}
                                        onChange={e => {
                                            if (e?.id) {
                                                setProductId(e.id)
                                            }
                                            else {
                                                setProductId()
                                            }
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                    />
                                </div>
                                <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); fetchReport() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>

                            </div>
                        </div>
                    </Module>
                </div>
                <div className="col-12 m-p-0">
                    <Module title="Retail Product Report">
                        <Table2 export searchable title="Retail Product Report"
                            data={productDetails}
                            allowMultipleExpanded={true}
                            columns={columns}
                            loading={isLoader}
                            subDataAccessor={subDataAccessor}
                            subDataId="subData"
                            initialMessage={initialMessage}
                        />
                    </Module>
                </div>
            </div>
        </>
    );
};

export default ProductSummary;
